import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, share, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { AdvancedPlatformsActions } from './advanced-platforms.action';
import { AdvancedPlatformsService } from '../../services/advanced-platforms.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AdvancedPlatformsEffects {
  constructor(
    private actions$: Actions<AdvancedPlatformsActions>,
    private advancedPlatformsService: AdvancedPlatformsService,
    private toastr: ToastrService
  ) {}

  public getPlatforms$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdvancedPlatformsActions.getPlatforms),
      switchMap(() => this.advancedPlatformsService.getPlatformsList()),
      map((platforms) => ({
        type: AdvancedPlatformsActions.getPlatformsSuccess,
        payload: platforms,
      })),
      catchError((error) =>
        this.handlerToastError(
          AdvancedPlatformsActions.getPlatformsError,
          error
        )
      ),
      share()
    )
  );

  public getSubscribes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdvancedPlatformsActions.getSubscribes),
      switchMap(() => this.advancedPlatformsService.getSubscriptions()),
      map((subscribes) => ({
        type: AdvancedPlatformsActions.getSubscribesSuccess,
        payload: subscribes,
      })),
      catchError((error) =>
        this.handlerToastError(
          AdvancedPlatformsActions.getSubscribesError,
          error
        )
      ),
      share()
    )
  );

  private handlerToastError(actionType: any, error: any) {
    this.toastr.error(`Ops! Ocorreu um erro, por favor tente mais tarde.`, '', {
      timeOut: 5000,
      progressBar: true,
      positionClass: 'toast-bottom-center',
      toastClass: 'toast--default font-small--medium font-light-color',
    });

    return of({ type: actionType, payload: error });
  }
}